import type {ContactId, LeadId} from '../types';
import type {LeadsAction} from '../leads/leads-types';
import {ActionTypes as LeadsActionTypes} from '../leads/leads-constants';

export type RelatedLeadsState = Partial<
    Record<
        ContactId,
        {
            isLoading: boolean;
            items: LeadId[];
        }
    >
>;

const defaultRelatedLeadsState = {
    isLoading: false,
    items: [],
} as const;
export const relatedLeadsReducer = (
    state: RelatedLeadsState | null | undefined = {},
    action: LeadsAction
): RelatedLeadsState => {
    switch (action.type) {
        case LeadsActionTypes.LEADS_FETCH_LIST_FOR_CONTACT_REQUEST: {
            // @ts-ignore
            const newState = state[action.payload]
                ? // @ts-ignore
                  {...state[action.payload], isLoading: true}
                : {...defaultRelatedLeadsState, isLoading: true};

            // @ts-ignore
            return {...state, [action.payload]: newState};
        }
        case LeadsActionTypes.LEADS_FETCH_LIST_FOR_CONTACT_FAILURE: {
            // @ts-ignore
            const newState = state[action.payload.contactId]
                ? // @ts-ignore
                  {...state[action.payload.contactId], isLoading: false}
                : {...defaultRelatedLeadsState, isLoading: false};

            // @ts-ignore
            return {...state, [action.payload.contactId]: newState};
        }
        case LeadsActionTypes.LEADS_FETCH_LIST_FOR_CONTACT_SUCCESS: {
            const leadIds = action.payload.response.listItems.map((item) => item.links.entity.id);
            const newState = {
                isLoading: false,
                items: leadIds,
            } as const;

            return {...state, [action.payload.contactId]: newState};
        }
        default:
            // @ts-ignore
            return state;
    }
};
